var React = require('react');

function CircleInline (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"24","cy":"24","r":"24","fill":"#E8E8E8"}));
}

CircleInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = CircleInline;

CircleInline.default = CircleInline;
